import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-notice",
  templateUrl: "./notice.component.html",
  styleUrls: ["./notice.component.scss"],
})
export class NoticeComponent implements OnInit {

  constructor(private attiveModal: NgbActiveModal) {
     this.attiveModal = attiveModal;
  }

  ngOnInit(): void { 
  }

  closeModal() {
    this.attiveModal.close(true);
  }
}
